import React from 'react';
import { Link } from 'react-router-dom';
import { Plane, ArrowRight, CheckCircle2 } from 'lucide-react';
import { heroContent, stats, services, whyChooseUs } from '../mock';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import SEO from '../components/SEO';

const Home = () => {
  return (
    <div className="home-page">
      <SEO 
        title="Home"
        description="African-owned aircraft leasing and financing company. Flexible leasing solutions for Boeing, Airbus, Embraer, and De Havilland aircraft serving airlines across Africa."
        keywords="aircraft leasing Africa, airplane financing, aviation leasing South Africa, Boeing lease, Airbus lease"
        canonicalUrl="/"
      />
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-headline">{heroContent.headline}</h1>
            <p className="hero-subheadline">{heroContent.subheadline}</p>
            <p className="hero-description">{heroContent.description}</p>
            <div className="hero-cta-group">
              <Link to="/fleet">
                <Button className="btn-primary">
                  {heroContent.ctaText}
                  <ArrowRight className="icon-right" />
                </Button>
              </Link>
              <Link to="/contact">
                <Button className="btn-secondary">
                  {heroContent.ctaSecondary}
                </Button>
              </Link>
            </div>
          </div>
          <div className="hero-image">
            <img 
              src="https://customer-assets.emergentagent.com/job_0ccb6f97-1bfb-4ee2-9332-dc85509860bf/artifacts/lqcivfxj_B737%20Ramp.jpeg"
              alt="Aircraft on ramp"
              className="hero-img"
            />
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services-section">
        <div className="section-header">
          <h2 className="section-title">Our Services</h2>
          <p className="section-subtitle">Comprehensive aircraft leasing and financing solutions</p>
        </div>
        <div className="services-grid">
          {services.map((service) => (
            <Card key={service.id} className="service-card">
              <CardContent className="service-content">
                <div className="service-icon">
                  <Plane size={32} />
                </div>
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="why-section">
        <div className="why-content">
          <div className="why-text">
            <h2 className="section-title">Why Savanna Skies</h2>
            <p className="section-subtitle">
              African expertise meets global standards in aircraft leasing
            </p>
            <div className="why-list">
              {whyChooseUs.map((item, index) => (
                <div key={index} className="why-item">
                  <CheckCircle2 className="why-icon" size={24} />
                  <div className="why-item-content">
                    <h3 className="why-item-title">{item.title}</h3>
                    <p className="why-item-description">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="why-image">
            <img 
              src="https://customer-assets.emergentagent.com/job_0ccb6f97-1bfb-4ee2-9332-dc85509860bf/artifacts/3p8o7z14_B737%20Cockpit.jpeg"
              alt="Aircraft cockpit"
              className="why-img"
            />
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-content">
          <h2 className="cta-title">Ready to Elevate Your Fleet?</h2>
          <p className="cta-subtitle">
            Partner with Savanna Skies for flexible aircraft leasing and financing solutions
          </p>
          <Link to="/contact">
            <Button className="btn-primary btn-large">
              Get in Touch
              <ArrowRight className="icon-right" />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;